import { useState } from "react";

const ROLES = ["Preparer – builds the payroll run and enters net pay from the accountant's record.",
  "Approver – a DIFFERENT admin reviews and approves the run.", "Payer – sends each payment from the business bank, outside this app.",
  "Reconciler – a DIFFERENT admin than the payer confirms each payment against the posted bank statement."];
const STEPS = ["Log into the business bank yourself, outside this app, on a trusted device.", "Check the Zelle daily/monthly sending limits before starting.",
  "Copy the recipient identifier and amount from the worksheet (Reveal & copy is logged).", "Verify the recipient NAME the bank shows matches the employee before sending.",
  "Send the payment.", "Copy the bank's confirmation code.", "Record it here the same day.", "A second admin reconciles against the posted bank statement."];
const CASES = [["Failure / return", "Mark the record Failed with the reason, confirm the recipient, then Retry with a new record."],
  ["Limit hit", "Send what the limit allows, record it as a partial payment, send the rest when the limit resets."],
  ["Wrong recipient", "Contact the bank immediately – Zelle payments generally can't be reversed. Record notes; never edit records."],
  ["Check / cash", "Record the check number or cash receipt number. Cash requires a receipt signed by the employee."]];

export function ZelleGuide() {
  const [open, setOpen] = useState(false);
  return (
    <section className="rounded-sm border border-white/10 bg-surface p-4" data-testid="zelle-procedure-guide">
      <button className="label-caps text-signal hover:text-white" onClick={() => setOpen(!open)} data-testid="zelle-guide-toggle">
        {open ? "Hide" : "Show"} manual Zelle procedure
      </button>
      {open && (
        <div className="mt-4 grid gap-6 text-xs text-zinc-300 lg:grid-cols-3">
          <div><p className="label-caps mb-2 text-zinc-500">Who does what</p><ul className="list-disc space-y-1 pl-4">{ROLES.map((r) => <li key={r}>{r}</li>)}</ul></div>
          <div><p className="label-caps mb-2 text-zinc-500">Bank steps</p><ol className="list-decimal space-y-1 pl-4">{STEPS.map((s) => <li key={s}>{s}</li>)}</ol></div>
          <div className="space-y-2"><p className="label-caps text-zinc-500">When something goes wrong</p>
            {CASES.map(([t, d]) => <p key={t}><span className="font-semibold text-white">{t}:</span> {d}</p>)}
            <p className="text-amber-200">This app never stores bank credentials or account numbers and never moves money.</p></div>
        </div>
      )}
    </section>
  );
}
